document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.article-content p, .article-sections p').forEach(p => {
    if (!p.textContent.trim()) p.remove();
  });

  document.querySelectorAll('.article-content li, .article-sections li').forEach(li => {
    const firstEl = li.firstElementChild;
    if (firstEl && (firstEl.tagName === 'STRONG' || firstEl.tagName === 'B')) return;

    const target = (firstEl && firstEl.tagName === 'P') ? firstEl : li;
    const html = target.innerHTML.trim();

    const colonIdx = html.indexOf(': ');
    const hyphenIdx = html.indexOf(' - ');
    const dashIdx = html.indexOf(' – ');

    let splitIdx = -1;
    let splitLen = 0;

    if (colonIdx > 0) { splitIdx = colonIdx; splitLen = 2; }
    else if (hyphenIdx > 0) { splitIdx = hyphenIdx; splitLen = 3; }
    else if (dashIdx > 0) { splitIdx = dashIdx; splitLen = 3; }

    if (splitIdx > 0) {
      const title = html.substring(0, splitIdx);
      const desc = html.substring(splitIdx + splitLen);
      target.innerHTML = `<strong>${title}</strong>${desc}`;
    }
  });
});
